import { useMemo } from 'react';
import cn from 'classnames';
import styles from '../MillionsIcon.module.scss';

type InstagramGradientIconProps = React.ComponentPropsWithoutRef<'svg'> & {
  className?: string;
  size?: number;
};

let instagramGradientIdCounter = 0;

const InstagramGradientIcon = ({
  className,
  size = 24,
  ...rest
}: InstagramGradientIconProps) => {
  const gradientId = useMemo(() => {
    instagramGradientIdCounter += 1;
    return `instagram-gradient-${instagramGradientIdCounter}`;
  }, []);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(styles.root, className)}
      data-icon-name="instagramGradient"
      aria-hidden="true"
      role="presentation"
      focusable="false"
      {...rest}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="3"
          y1="3"
          x2="21"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C837AB" />
          <stop offset="0.351" stopColor="#C61BFA" />
          <stop offset="0.764" stopColor="#F43F36" />
          <stop offset="1" stopColor="#FFAB00" />
        </linearGradient>
      </defs>
      <path
        d="M11.999 7.37695C10.7726 7.37695 9.59651 7.86412 8.72934 8.73129C7.86217 9.59846 7.375 10.7746 7.375 12.001C7.375 13.2273 7.86217 14.4034 8.72934 15.2706C9.59651 16.1378 10.7726 16.625 11.999 16.625C13.2254 16.625 14.4015 16.1378 15.2687 15.2706C16.1358 14.4034 16.623 13.2273 16.623 12.001C16.623 10.7746 16.1358 9.59846 15.2687 8.73129C14.4015 7.86412 13.2254 7.37695 11.999 7.37695ZM11.999 15.004C11.2023 15.004 10.4382 14.6875 9.87485 14.1241C9.31149 13.5607 8.995 12.7967 8.995 12C8.995 11.2032 9.31149 10.4392 9.87485 9.8758C10.4382 9.31245 11.2023 8.99595 11.999 8.99595C12.7957 8.99595 13.5598 9.31245 14.1231 9.8758C14.6865 10.4392 15.003 11.2032 15.003 12C15.003 12.7967 14.6865 13.5607 14.1231 14.1241C13.5598 14.6875 12.7957 15.004 11.999 15.004Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M16.8055 8.28491C17.4009 8.28491 17.8835 7.80227 17.8835 7.20691C17.8835 6.61154 17.4009 6.12891 16.8055 6.12891C16.2102 6.12891 15.7275 6.61154 15.7275 7.20691C15.7275 7.80227 16.2102 8.28491 16.8055 8.28491Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M20.533 6.11186C20.3015 5.51404 19.9477 4.97114 19.4943 4.51792C19.0409 4.06469 18.4979 3.71113 17.9 3.47986C17.2003 3.21722 16.4611 3.0752 15.714 3.05986C14.751 3.01786 14.446 3.00586 12.004 3.00586C9.56195 3.00586 9.24895 3.00586 8.29395 3.05986C7.54734 3.07442 6.80871 3.21646 6.10995 3.47986C5.51189 3.71086 4.96872 4.06433 4.51529 4.51759C4.06186 4.97085 3.70818 5.51388 3.47695 6.11186C3.21426 6.81147 3.07257 7.5507 3.05795 8.29786C3.01495 9.25986 3.00195 9.56486 3.00195 12.0079C3.00195 14.4499 3.00195 14.7609 3.05795 15.7179C3.07295 16.4659 3.21395 17.2039 3.47695 17.9049C3.70883 18.5026 4.06285 19.0454 4.51639 19.4986C4.96993 19.9518 5.51302 20.3054 6.11095 20.5369C6.80839 20.8101 7.54732 20.9622 8.29595 20.9869C9.25895 21.0289 9.56395 21.0419 12.006 21.0419C14.448 21.0419 14.761 21.0419 15.716 20.9869C16.4631 20.9717 17.2022 20.83 17.902 20.5679C18.4997 20.336 19.0426 19.9822 19.4959 19.5288C19.9493 19.0755 20.3031 18.5326 20.535 17.9349C20.798 17.2349 20.939 16.4969 20.954 15.7489C20.997 14.7869 21.01 14.4819 21.01 12.0389C21.01 9.59586 21.01 9.28586 20.954 8.32886C20.9423 7.57113 20.7999 6.82111 20.533 6.11186ZM19.315 15.6439C19.3085 16.2202 19.2033 16.7911 19.004 17.3319C18.8538 17.7207 18.6239 18.0739 18.329 18.3685C18.0342 18.6632 17.6809 18.8929 17.292 19.0429C16.7572 19.2413 16.1923 19.3465 15.622 19.3539C14.672 19.3979 14.404 19.4089 11.968 19.4089C9.52995 19.4089 9.28095 19.4089 8.31295 19.3539C7.74288 19.3469 7.17828 19.2417 6.64395 19.0429C6.25364 18.8938 5.89895 18.6646 5.60284 18.3698C5.30673 18.0751 5.07579 17.7215 4.92495 17.3319C4.7284 16.7969 4.62326 16.2327 4.61395 15.6629C4.57095 14.7129 4.56095 14.4449 4.56095 12.0089C4.56095 9.57186 4.56095 9.32286 4.61395 8.35386C4.62042 7.77788 4.72561 7.20728 4.92495 6.66686C5.22995 5.87786 5.85495 5.25686 6.64395 4.95486C7.17854 4.757 7.74298 4.65182 8.31295 4.64386C9.26395 4.60086 9.53095 4.58886 11.968 4.58886C14.405 4.58886 14.655 4.58886 15.622 4.64386C16.1924 4.65072 16.7573 4.75593 17.292 4.95486C17.6809 5.10513 18.0341 5.33506 18.3289 5.62989C18.6238 5.92472 18.8537 6.27793 19.004 6.66686C19.2005 7.20181 19.3056 7.76602 19.315 8.33586C19.358 9.28686 19.369 9.55386 19.369 11.9909C19.369 14.4269 19.369 14.6889 19.326 15.6449H19.315V15.6439Z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
};

export default InstagramGradientIcon;
